export const environment = {
    production: false,
    apiUrl: 'https://api.jaca.com.py/api/v1/ec/',
    viewUrl: 'https://api.jaca.com.py',
    presetToken: 'KIlTS8g1YkCCARv0EoRHCDMSFTkq8VbkRMVfUbiACJ8uA70fdqfCIXmfJ9osdWpKfmwUWD2WAgkoa',
    tokenExpiration: 3600000, // 1 hora en milisegundos
    refreshTokenExpiration: 86400000, // 24 horas en milisegundos
    // Configuración de la empresa para Packing List
    company: {
        name: 'DISTRIDENT S.A.',
        address: 'Av. Principal 123',
        city: 'Asunción',
        postalCode: '1234',
        phone: '[000-000-0000]',
        whatsapp: '[000-000-0000]',
        website: 'www.distrident.com.py',
        email: 'info@distrident.com.py'
    }
};
